export const getNameInitials = (firstName?: string, lastName?: string): string => {
  const parts = [firstName, lastName]
    .map(part => part?.trim())
    .filter((part): part is string => Boolean(part));

  if (parts.length === 0) {
    return '';
  }

  return Array.from(parts.map(part => Array.from(part)[0] ?? '').join(''))
    .slice(0, 2)
    .join('')
    .toUpperCase();
};
